import api from "./axiosInstance";

export const getCompanyExpenses = async () => {
  const res = await api.get("api/v1/company-expenses/");
  console.log('--', res.data);
  return res.data;
};

export const createCompanyExpenses = async (payload) => {
  const res = await api.post(`api/v1/company-expenses/`, payload);
  return res.data;
};

